export default __webpack_public_path__ + "5d7fa0ee0a61c4182b4cf7a076195ee4.svg";